/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FusionMelcoFusionModelsCustomProductDesignHoop
 */
export interface FusionMelcoFusionModelsCustomProductDesignHoop {
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoFusionModelsCustomProductDesignHoop
     */
    backward_compatibility_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoFusionModelsCustomProductDesignHoop
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoFusionModelsCustomProductDesignHoop
     */
    name?: string | null;
}

export function FusionMelcoFusionModelsCustomProductDesignHoopFromJSON(json: any): FusionMelcoFusionModelsCustomProductDesignHoop {
    return FusionMelcoFusionModelsCustomProductDesignHoopFromJSONTyped(json, false);
}

export function FusionMelcoFusionModelsCustomProductDesignHoopFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoFusionModelsCustomProductDesignHoop {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'backward_compatibility_id': !exists(json, 'backward_compatibility_id') ? undefined : json['backward_compatibility_id'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function FusionMelcoFusionModelsCustomProductDesignHoopToJSON(value?: FusionMelcoFusionModelsCustomProductDesignHoop | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'backward_compatibility_id': value.backward_compatibility_id,
        'id': value.id,
        'name': value.name,
    };
}


